export const SPENDING_PLAN_ONBOARDING_DIALOG_HEIGHT = 560;

export const spendingPlanOnboardingDialogPaperSx = {
  height: SPENDING_PLAN_ONBOARDING_DIALOG_HEIGHT,
};
